export default class SummaryModel {
  public annoucement: string[]

  constructor() {
    this.annoucement = []
  }
}